module.exports = __webpack_public_path__ + "static/media/aces_s_off.a95cb9c8.svg";